import React from 'react';
import { History } from 'lucide-react';
import { Button } from '@shared/ui/button';
import { useRecentPages } from '@shared/activity';
import { useLayoutPrefs } from '../layoutPrefs';
import { cn } from '@shared/lib/utils';

export const RightbarToggle: React.FC = () => {
  const { rightOpen, toggleRight } = useLayoutPrefs();
  const count = useRecentPages().length;

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleRight}
      className={cn(
        'h-7 gap-1.5 px-2 text-muted-foreground hover:text-foreground shrink-0',
        rightOpen && 'text-foreground bg-muted'
      )}
      aria-label="Toggle recent activity panel"
      aria-pressed={rightOpen}
    >
      <History className="h-4 w-4" />
      <span className="hidden sm:inline text-xs">Recent</span>
      {count > 0 && (
        <span className="text-[10px] leading-none rounded-full bg-primary text-primary-foreground px-1.5 py-0.5">
          {count}
        </span>
      )}
    </Button>
  );
};
